import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PageComponent } from '../page/page.component';
import { IonButton } from '@ionic/angular/standalone';

/**
 * 404 Not Found component for handling page not found errors.
 * Uses the shared PageComponent for consistent layout.
 */
@Component({
  selector: 'crowdctrl-not-found',
  imports: [PageComponent, IonButton],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css',
  standalone: true,
})
export class NotFoundComponent {
  constructor(private router: Router) {}

  goHome(): void {
    this.router.navigate(['/']);
  }
}
